import type { GithubIssueLink } from '@/lib/github-issues/types';
import { useQuery } from '@tanstack/react-query';

/**
 * The GitHub issue linked to a pull request on GitHub, as used for review
 * context. The link is managed on GitHub, so this is read-only. Null when the
 * installation has not enabled GitHub Issues.
 */
export function useLinkedGithubIssueQuery(owner: string, repo: string, number: number) {
  return useQuery<GithubIssueLink | null>({
    queryKey: ['linked-github-issue', owner, repo, number],
    queryFn: async () => {
      const params = new URLSearchParams({ owner, repo, number: String(number) });
      const res = await fetch(`/api/github-issues/linked-issue?${params.toString()}`);
      if (!res.ok) {
        // Carry the status so the global retry policy can tell 404s apart.
        throw Object.assign(new Error('Failed to fetch the linked GitHub issue'), {
          status: res.status,
        });
      }
      const data: { issue: GithubIssueLink | null } = await res.json();
      return data.issue;
    },
    enabled: Boolean(owner && repo && number),
    // Secondary sidebar data: failed lookups stay failed until the next mount.
    retry: false,
  });
}
